module.exports = __webpack_public_path__ + "img/11.e4e2c86f.jpg";